<template lang="pug">
  v-container(fill-height fluid grid-list-md-4 )
    v-row
      v-col(xs='12' sm='6' md='3' v-for='item, index in elementos' :key='index')
        v-hover( v-slot:default="{ hover }" )
          v-card( :elevation="hover ? 12 : 0" :color='hover ? "white": "grey lighten-5"' @click='item.callback()' )
            v-card-text
              v-col(align='center')
                v-icon.mb-4(x-large :color='hover ? "primary" : "grey"') {{ item.icon }}
                p.black--text {{item.name}}

      
                    
      v-dialog(v-model='dialog' persistent max-width='600px')
        v-card
          v-card-title
            span.headline Cambio de contraseña
          v-card-text
            v-form( v-model='changePasswordForm')
              v-container(grid-list-md)
                v-layout(wrap)
                  v-flex(xs12)
                    v-text-field(label='Contraseña actual*' type='password' required :rules='[rules.required, rules.minEight]' v-model='oldPassword')
                  v-flex(xs12)
                    v-text-field(label='Nueva contraseña*' type='password' required :rules='[rules.required, rules.minEight]' v-model='newPassword')
                  v-flex(xs12 sm6)
          v-card-actions
            v-spacer
            v-btn(color='primary' @click='dialog = false') Cerrar
            v-btn(color='primary' @click='editPassword()') Guardar 
                   
          
           

          
</template>
<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import {mainAuth, credential} from '@/FirebaseConfig.js'

export default {
  data: ()=>({
    dialog: false,
    changePasswordForm: false,
    oldPassword:'',
    newPassword:'',
  }),
  methods: {
    editPassword(){
      if(this.changePasswordForm){
        let user = mainAuth.currentUser
        this.reauthenticate(user, this.oldPassword)
        this.changePassword(user, this.oldPassword, this.newPassword )   
      }
    },
    changePassword(user, currentPassword, newPassword){
      this.reauthenticate(user, currentPassword).then(() => {
        user.updatePassword(newPassword).then(() => {
          this.dialog = false 
        }).catch(error => console.log(error))
      }).catch(error => console.log(error))
    },
    reauthenticate(user, currentPassword) {
      var cred = credential( user.email, currentPassword)
      return user.reauthenticateAndRetrieveDataWithCredential(cred);
    }
  },
  computed:{   
    ...mapGetters({
      recordSetting:'Privileges/recordSetting',
    }),
    ...mapState({
      rules: state => state.Helpers.rules,
    }),
    elementos(){

      let result =  this.recordSetting.map(item => ( { icon: item.icon, name: item.name, callback: () => this.$router.push({ name:item.routerName, params: { customerName: this.$route.params.customerName} }) }) )
      result.push({ icon: 'fas fa-cog', name: 'Cambiar contraseña', callback: () => this.dialog=true })
      return result
      
    }
  }
  
}
</script>

     
